"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGCodeInput = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

require("./CodeInput.scss");

var _ = require("../../..");

var BACKSPACE_KEY = 8;
var LEFT_ARROW_KEY = 37;
var UP_ARROW_KEY = 38;
var RIGHT_ARROW_KEY = 39;
var DOWN_ARROW_KEY = 40;
var E_KEY = 69;

var BHGCodeInput = function BHGCodeInput(props) {
  var type = props.type,
      inputLength = props.inputLength,
      _props$separator = props.separator,
      divider = _props$separator.divider,
      interval = _props$separator.interval,
      onChange = props.onChange,
      disabled = props.disabled,
      error = props.error;

  var _useState = (0, _react.useState)(new Array(inputLength).fill('')),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = (0, _react.useState)(Math.floor(Math.random() * 1000).toString()),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 1),
      uuid = _useState4[0];

  var handleChange = function handleChange(e) {
    var value = String(e.target.value);
    value = value.toLowerCase();

    if (type === 'number') {
      value = value.replace(/[^\d]/g, '');
    }

    value = value.split('').filter(function (currChar) {
      return !['-', '.'].includes(currChar);
    }).join('');
    var fullValue = value;

    if (value !== '') {
      var input = values.slice();

      if (value.length > 1) {
        value.split('').map(function (chart, i) {
          if (Number(e.target.dataset.id) + i < inputLength) {
            input[Number(e.target.dataset.id) + i] = chart;
          }

          return false;
        });
      } else {
        input[Number(e.target.dataset.id)] = value;
      }

      var newTarget = document.getElementById(Number(e.target.dataset.id) < input.length ? 'bhg-ci-' + (Number(e.target.dataset.id) + 1) + uuid : 'bhg-ci-' + e.target.dataset.id + uuid);

      if (newTarget) {
        newTarget.focus();
        newTarget.select();
      }

      fullValue = input.join('').trim();
      setValues(input);
    }

    if (onChange && fullValue.length === inputLength) {
      onChange(fullValue);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    var target = Number(e.target.dataset.id),
        nextTarget = document.getElementById('bhg-ci-' + (target + 1) + uuid),
        prevTarget = document.getElementById('bhg-ci-' + (target - 1) + uuid),
        currentTarget = document.getElementById('bhg-ci-' + target + uuid);
    var input, value;
    [189, 190].map(function (item) {
      if (item === e.keyCode) {
        e.preventDefault();
        return true;
      }
    });

    switch (e.keyCode) {
      case BACKSPACE_KEY:
        e.preventDefault();
        currentTarget.value = '';
        input = values.slice();
        input[target] = '';
        value = input.join('').trim();
        setValues(input);

        if (currentTarget.value === '') {
          if (prevTarget) {
            prevTarget.focus();
            prevTarget.select();
          }
        }

        if (onChange && value.length === inputLength) {
          onChange(value);
        }

        break;

      case LEFT_ARROW_KEY:
        e.preventDefault();

        if (prevTarget) {
          prevTarget.focus();
          prevTarget.select();
        }

        break;

      case RIGHT_ARROW_KEY:
        e.preventDefault();

        if (nextTarget) {
          nextTarget.focus();
          nextTarget.select();
        }

        break;

      case UP_ARROW_KEY:
        e.preventDefault();
        break;

      case DOWN_ARROW_KEY:
        e.preventDefault();
        break;

      case E_KEY:
        // This case needs to be handled because of https://stackoverflow.com/questions/31706611/why-does-the-html-input-with-type-number-allow-the-letter-e-to-be-entered-in
        if (e.target.type === 'number') {
          e.preventDefault();
          break;
        }

        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-code-input"
  }, values.map(function (x, i) {
    var id = "bhg-ci-" + i + uuid;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (i === interval || Array.isArray(interval) && interval.includes(i)) && /*#__PURE__*/_react.default.createElement("div", {
      className: "code-input-divider"
    }, divider), /*#__PURE__*/_react.default.createElement(_.BHGInput, {
      key: id,
      id: id,
      value: x,
      "data-id": i,
      disabled: disabled,
      error: error,
      onChange: handleChange,
      onKeyDown: handleKeyDown
    }));
  }));
};

exports.BHGCodeInput = BHGCodeInput;
BHGCodeInput.defaultProps = {
  type: 'number',
  inputLength: 6,
  disabled: false,
  error: false,
  onChange: function onChange(e) {
    return console.log(e);
  },
  separator: {
    interval: 3,
    divider: '-'
  }
};